import ApiService from "@/core/services/ApiService";

class BitacoraService {

    public static Tutoriales() {
        ApiService.setHeader()
        return ApiService.get('api/bitacora', 'tutorials')
    }

}

export default BitacoraService;